import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import type {
  CentralMappingCategory,
  CentralMappingMappingEntry,
} from 'lumen/models';

interface TdDeepDiscountSignature {
  Args: {
    column: {
      deepDiscountCategory?: CentralMappingCategory;
      isReadOnly: boolean;
    };
    row: {
      isDeepDiscount: boolean;
      mappingEntry: CentralMappingMappingEntry;
      setCategory: (category: CentralMappingCategory | null) => void;
    };
  };
}

export default class HotelSettingsCentralMappingTablesCellsTdDeepDiscount extends Component<TdDeepDiscountSignature> {
  get isChecked(): boolean {
    return this.args.row.isDeepDiscount;
  }

  @action
  toggle(): void {
    const { row, column } = this.args;

    if (this.isChecked) {
      row.setCategory(null);
    } else if (column.deepDiscountCategory) {
      row.setCategory(column.deepDiscountCategory);
    }
  }

  <template>
    <div class="flex items-center justify-center">
      <PrismCheckbox
        @checked={{this.isChecked}}
        @disabled={{@column.isReadOnly}}
        @onChange={{this.toggle}}
      />
    </div>
  </template>
}
